<app-table [useFixedHeader]="true">
  <app-table-headers>
    <app-table-header class="flex">ID</app-table-header>
    <app-table-header class="badge-cell flex-center">State</app-table-header>
    <app-table-header>Display Name</app-table-header>
    <app-table-header class="flex-half">Package</app-table-header>
    <app-table-header class="flex-half">Users</app-table-header>
    <app-table-header
      class="click-header flex-half"
      (click)="sortAccounts.emit()"
    >
      Created At
      <i
        class="fas"
        [ngClass]="(sortOnAscending$ | async) ? 'fa-caret-up' : 'fa-caret-down'"
      ></i>
    </app-table-header>
    <app-table-header class="flex-half">Category</app-table-header>
    <app-table-header class="flex-double">Description</app-table-header>
  </app-table-headers>

  <ng-template #empty>
    <app-table-content-empty [isLoading]="isLoadingAccounts">
      <ng-container loading><p>Fetching accounts ...</p></ng-container>

      <ng-container nodata *ngIf="!isLoadingAccounts">
        <p>No accounts found</p>
      </ng-container>
    </app-table-content-empty>
  </ng-template>

  <app-table-content *ngIf="!isLoadingAccounts; else empty">
    <ng-container *ngIf="accounts && accounts.length; else empty">
      <app-table-row *ngFor="let account of accounts">
        <app-table-cell class="flex">
          <a
            routerLink="/au/accounts/{{ account.id }}"
            [queryParams]="queryParams(account)"
          >
            <strong>{{ account.id }}</strong>
          </a>
        </app-table-cell>
        <app-table-cell class="badge-cell flex-center">
          <span
            [ngClass]="'badge badge-' + getAccountStateClass(account.state)"
          >
            {{ account.state }}
          </span>
        </app-table-cell>
        <app-table-cell>{{ account.displayName }}</app-table-cell>
        <app-table-cell class="flex-half">
          {{ licensePackageMap(account.licensePackage) }}
        </app-table-cell>
        <app-table-cell class="flex-half">
          {{ account.usersCount }}
        </app-table-cell>
        <app-table-cell class="flex-half">
          {{ account.created | date }}
        </app-table-cell>
        <app-table-cell class="flex-half">
          {{ accountCategoriesMap(account.category) }}
        </app-table-cell>
        <app-table-cell class="flex-double">
          {{ account.description }}
        </app-table-cell>
      </app-table-row>
    </ng-container>
  </app-table-content>
</app-table>
<div
  *ngIf="!loadAllAccounts && !isLoadingAccounts"
  class="load-all"
  (click)="loadAll()"
>
  <span>Load all</span>
</div>
